import { Grid } from "@chakra-ui/react";
import React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
export const ExpandableGrid = _ref => {
  let {
    isOpen,
    classNames,
    children
  } = _ref;
  return /*#__PURE__*/_jsx(Grid, {
    className: classNames,
    gridTemplateRows: isOpen ? "1fr" : "0fr",
    transition: "grid-template-rows 300ms",
    children: children
  });
};